import { useFlags } from 'launchdarkly-react-client-sdk';

/** LaunchDarkly keys used for the plan page UI revamp (support both casings). */
export const getPlanPageUiRevampEnabled = (flags?: Record<string, boolean | undefined>): boolean =>
  Boolean(flags?.planPageUiRevamp ?? flags?.planPageUIRevamp);

export const usePlanPageUiRevamp = (): boolean => {
  const flags = useFlags();
  return getPlanPageUiRevampEnabled(flags);
};

/** Use with shared components that accept variant="revamp" — revamp UI only when flag is on. */
export const usePlanPageRevampVariant = (variant: 'legacy' | 'revamp' = 'legacy'): boolean => {
  const enabled = usePlanPageUiRevamp();
  return enabled && variant === 'revamp';
};
